 
import {
    Document16Regular,
    Bookmark24Regular,
    Bookmark24Filled
} from "@fluentui/react-icons";
import {useState} from "react";
import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    hasFileAttached?: boolean;
    attachedFileName?: string;
    onSavePrompt?: (message: string) => void;
    isSaved?: boolean;
}

export const UserChatMessage = ({
    message,
    hasFileAttached,
    attachedFileName,
    onSavePrompt,
    isSaved = false
}: Props) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleSaveClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onSavePrompt) {
            onSavePrompt(message);
        }
    };

    return (
        <div className={styles.container}>
            <div
                className={styles.messageWrapper}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div className={styles.message}>
                    {message}

                    {hasFileAttached && (
                        <div className={styles.fileAttachmentIndicator}>
                            <Document16Regular className={styles.fileIcon} />
                            <span>{attachedFileName || "File attached"}</span>
                        </div>
                    )}
                </div>
                <button
                    className={`${styles.bookmarkButton} ${
                        isHovered || isSaved ? styles.visible : ""
                    }`}
                    onClick={handleSaveClick}
                    title={isSaved ? "Saved" : "Save prompt"}
                >
                    {isSaved ? (
                        <Bookmark24Filled className={styles.bookmarkIconSaved} />
                    ) : (
                        <Bookmark24Regular className={styles.bookmarkIcon} />
                    )}
                </button>
            </div>
        </div>
    );
};
